import { getUuid } from '@/utils/util';

const OSS = require('ali-oss');

const ossClient = new OSS({
  region: 'oss-cn-beijing',
  accessKeyId: 'LTAIL5h5skq50IO2',
  accessKeySecret: '6HGOoApgcLdn7pvykHQ5g6ZGiLYtwf',
  bucket: 'p2ps-vip-saas-resource',
  useFetch: false,
  secure: true,
});

async function ossPut(fileName, fileUrl) {
  try {
    const point = fileName.lastIndexOf('.');
    const suffix = fileName.substr(point);
    const path = getUuid() + suffix;
    const result = await ossClient.put(path, fileUrl);
    return result;
  } catch (err) {
    console.log(err);
  }
}

async function multipartUpload(fileName, fileUrl, progress) {
  try {
    const point = fileName.lastIndexOf('.');
    const suffix = fileName.substr(point);
    const path = `mango/pc/${getUuid()}${suffix}`;
    const result = await ossClient.multipartUpload(path, fileUrl, {
      partSize: 102400,
      progress,
    });
    return result;
  } catch (e) {
    // 捕获超时异常
    if (e.code === 'ConnectionTimeoutError') {
      console.log('超时');
    }
    console.log(e);
  }
}

export { ossPut, multipartUpload };
